export default __webpack_public_path__ + "static/media/style-belgardSubterra.fd29bc02.jpg";